const MINUTE = 1000 * 60;
export const STALE_TIME = 5 * MINUTE;
export const CACHE_TIME = 60 * MINUTE;
